import { atom } from 'recoil';

import { User } from '@hooks/types';

import { Atoms } from '../constants';

export const userProfileAtom = atom({
  key: Atoms.userProfile,
  default: {} as User,
});
